var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.206,
    height: 21.608,
    viewBox: "0 0 16.206 21.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(-1199.897 -569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-excel",
    "data-name": "Icon awesome-file-excel",
    d: "M9.454,5.74V0H1.013A1.01,1.01,0,0,0,0,1.013V20.6a1.01,1.01,0,0,0,1.013,1.013h14.18A1.01,1.01,0,0,0,16.206,20.6V6.753h-5.74A1.016,1.016,0,0,1,9.454,5.74Zm2.536,4.495L9.454,14.18l2.536,3.946a.507.507,0,0,1-.426.781H10.091a.508.508,0,0,1-.447-.266c-.827-1.528-1.54-2.9-1.54-2.9-.27.625-.422.844-1.545,2.9a.5.5,0,0,1-.443.266H4.642a.507.507,0,0,1-.426-.781l2.545-3.946L4.216,10.239a.506.506,0,0,1,.426-.781H6.111a.508.508,0,0,1,.447.266c1.1,2.06.844,1.418,1.545,2.891,0,0,.257-.494,1.545-2.891a.508.508,0,0,1,.447-.266h1.469A.5.5,0,0,1,11.99,10.234Zm4.216-5.09V5.4H10.8V0h.257a1.012,1.012,0,0,1,.717.3l4.132,4.136A1.01,1.01,0,0,1,16.206,5.145Z",
    transform: "translate(1199.897 569)",
    fill: "#1f7244"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcel);
export default __webpack_public_path__ + "static/media/icon-excel.f35f91de8f59c43b3c982e40c6603a8e.svg";
export { ForwardRef as ReactComponent };